import { useTranslations } from 'next-intl';
import BgContainer from '@components/BgContainer';
import QueryLink from '@components/QueryLink';

export default function BannerFrontMiddle2Auction() {
  const t = useTranslations('Banners.BannerFrontMiddle2Auction');
  return (
    <BgContainer>
      <div className='items-strech flex flex-wrap items-center justify-between py-2 text-lg md:flex-nowrap'>
        <div className='max-w-[28em] border-l-2 border-brand py-2 pl-4 md:mr-10 md:py-4'>
          {t.rich('content', {
            b: (chunks) => <b className='text-brand'>{chunks}</b>,
          })}
        </div>
        <div className='mt-6 flex w-full items-center justify-end md:mt-0 md:w-auto'>
          <QueryLink
            query={{ modal: 'login' }}
            className='font-bold text-brand underline'
          >
            {t('button')}
          </QueryLink>
        </div>
      </div>
    </BgContainer>
  );
}
